import { HomeFooter } from '@/features/home/components/HomeFooter'

/** Same copyright bar as logged-in home; stays pinned in auth layouts. */
export function AuthFooter() {
  return <HomeFooter testId="auth-footer" />
}
